import { Specimen } from "pwapi";

import { CaseDiagnosis } from "custom-models";

import { SlideDetailState } from "reducers/slideDetailReducer";

import { CaseDetailState } from "../reducers/caseDetailReducer";

export const useCurrentSpecimenDiagnoses = (
  caseDetailObject: CaseDetailState,
  slideDetailObject: SlideDetailState,
  specimen?: Specimen
) => {
  const selectedSpecimen = slideDetailObject.specimen?.id
    ? slideDetailObject.specimen
    : specimen;
  return caseDetailObject.specimenDetail.find(
    (spec) => selectedSpecimen?.id === spec.id
  )?.diagnoses;
};

export const useLISFinalizedDiagnosis = (case_diagnosis?: CaseDiagnosis[]) => {
  // NOTE: .find because there should only be one?
  // this might change in the future with AMEND and ADDEND
  return case_diagnosis?.find(
    (d) => d.source === CaseDiagnosis.source.LIS_FINALIZED
  );
};
